import {
  Store,
  LineChart,
  LayoutGrid,
  Home,
  PlayCircle,
  type LucideIcon,
  AlertTriangle,
} from "lucide-react";

export interface NavItem {
  /** Route the entry links to. */
  to: string;
  label: string;
  icon: LucideIcon;
  /** Stable hook for tutorials and e2e selectors. */
  id?: string;
}

/**
 * The primary destinations, in the order they appear in the rail. Keep this
 * list short — it is the app's whole top-level map, and every entry costs
 * vertical space in the collapsed rail as well as the expanded one.
 */
export const NAV_ITEMS: NavItem[] = [
  { to: "/home", label: "Home", icon: Home, id: "nav-link-home" },
  { to: "/sites", label: "Sites", icon: Store, id: "nav-link-sites" },
  {
    to: "/devices",
    label: "Devices",
    icon: LayoutGrid,
    id: "nav-link-devices",
  },
  {
    to: "/monitoring",
    label: "Monitoring",
    icon: LineChart,
    id: "nav-link-monitoring",
  },
  {
    to: "/alarms",
    label: "Alarms",
    icon: AlertTriangle,
    id: "nav-link-alarms",
  },
  {
    to: "/recordings",
    label: "Recordings",
    icon: PlayCircle,
    id: "nav-link-recordings",
  },
];

/**
 * Every row in the rail — the nav links and the footer's notification and help
 * triggers — shares this shape so the column reads as one list rather than a
 * list with some buttons stuck underneath it.
 *
 * The padding does not change with the rail's width: holding the icons at a
 * fixed offset from the left edge means they stay put while the rail animates,
 * instead of sliding between centred and left-aligned. At the collapsed width
 * that lands them within a couple of pixels of centre anyway.
 */
export const RAIL_ROW =
  "relative flex w-full items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors";

/** Colours for a rail row that is not the current page. */
export const RAIL_ROW_IDLE =
  "text-neutral-400 hover:bg-neutral-800 hover:text-neutral-100";
